import { useState } from 'react';
import PropTypes from 'prop-types';
import { getAdminInfo } from 'legacy-src/queries';
import useGetActions from './useGetActions';

const useFetchAdminCoord = (props) => {
  const { client, subject, dispatch } = props;
  const [state, setState] = useState(null);

  const actions = useGetActions({
    dispatch,
  });

  const loadAdminCoordInfo = ({ userData, router, params }) => {
    client
      .query({
        query: getAdminInfo,
        fetchPolicy: 'cache-first',
        variables: {
          id: subject,
        },
      })
      .then((response) => {
        const { adminSubject } = response;

        setState(response);
        actions.setAdminInfoAction({
          adminInfo: adminSubject,
        });
        actions.setUserSubjectsAction({ subjects: userData.adminSubjects });
        actions.setSubjectAction(userData, router, params);
      });
  };

  return [state, loadAdminCoordInfo];
};

useFetchAdminCoord.propTypes = {
  client: PropTypes.object.isRequired,
  subject: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default useFetchAdminCoord;
